import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchHouseholdSequenceEnrollments } from "./api"

export function useFetchHouseholdSequenceEnrollments(householdId: string, options?: { enabled?: boolean }) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["household-sequence-enrollments", householdId],
    enabled: options?.enabled,
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchHouseholdSequenceEnrollments(context, householdId)
    },
  })
}
